<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz13-9"><a href="#/contents#RR_10" id="CC_10"> Floyd’s Punch in the Mouth</a></p>
<p class="tx6" id="pz13-10"><i> Not in the nose this time. </i></p>
<p class="tx5" id="pz13-11"><b> 2 quarts water </b></p>
<p class="tx5" id="pz13-13"><b> 2 cups sugar </b></p>
<p class="tx5" id="pz13-15"><b> Juice of 2 lemons </b></p>
<p class="tx5" id="pz13-12"><b> 1 large can pineapple juice </b></p>
<p class="tx5" id="pz13-14"><b> 2 packages Kool-Aid, any flavor </b></p>
<p class="tx5" id="pz13-16"><b> 1 large bottle ginger ale </b></p>
<p class="tx1" id="pz13-17"><span class="dcap">M</span>ix all ingredients, except ginger ale, and chill. Add chilled ginger ale when ready to serve.</p>
<p class="tx" id="pz13-18"> Makes 40 punch cups.</p>
<p class="txrr" id="pz13-19"> <i>Judy B. Coleman—Asheboro, North Carolina</i></p>
<div class="box" id="ABm">
<p class="tx1a" id="pA16"><i>Barney’s about to float out of the drugstore:</i></p>
<table id="pA6M">
<tbody id="A6M" style="vertical-align: top;">
<tr id="tr-A6M-0">
<td id="td-A6M-0-0"><p class="txtb">BARNEY:</p></td>
<td id="td-A6M-0-1">Another root beer float.</td>
</tr>
<tr id="tr-A6M-1">
<td id="td-A6M-1-0"><p class="txtb">ELLIE:</p></td>
<td id="td-A6M-1-1">Barney, don’t you think you’ve had enough?</td>
</tr>
<tr id="tr-A6M-2">
<td id="td-A6M-2-0"><p class="txtb">BARNEY:</p></td>
<td id="td-A6M-2-1">Ellie, you let me worry about that.</td>
</tr>
<tr id="tr-A6M-3">
<td id="td-A6M-3-0"><p class="txtb">ELLIE:</p></td>
<td id="td-A6M-3-1">But Barney, four inside of fifteen minutes! Putting all that ice cream and soda in your stomach—</td>
</tr>
<tr id="tr-A6M-4">
<td id="td-A6M-4-0"><p class="txtb">BARNEY:</p></td>
<td id="td-A6M-4-1">Ellie, if you won’t sell them to me, I’ll just buy it some-wheres else.</td>
</tr>
</tbody>
</table></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter10.vue?ee041e32